const sharedStyles = {
  fontFamily: 'Arial',

  lineHeight: '1.7em',
  fontSize: '1.2em',

  '& *': {
    fontFamily: 'Helvetica, Arial, sans-serif',
    color: 'black',
  },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    display: 'block',
  },

  '& p': {
    fontSize: '14px',
    lineHeight: 1.6,
  },

  '& h1': {
    fontSize: '28px',
    fontWeight: '500',
    margin: '1em 0',
  },
  '& h2': {
    fontSize: '21px',
    fontWeight: '500',
    margin: '1em 0',
  },
  '& h3': {
    fontSize: '17px',
    fontWeight: '500',
    margin: '1em 0',
  },
  '& .field': {
    display: 'inline',
  },
};

export const pdfStyles = {
  '@page': {
    size: 'A4',
    marginTop: '20mm',
    marginRight: '25mm',
    marginBottom: '21mm',
    marginLeft: '25mm',
    ...sharedStyles,
  },
  body: {
    marginTop: '15mm',
    marginRight: '10mm',
    marginBottom: '12mm',
    marginLeft: '15mm',
    ...sharedStyles,
  },
};

export const agreementStyles = {
  '& .field': {
    backgroundColor: 'lightgreen',
    cursor: 'pointer',
    outline: '1px dotted black',
    padding: '4px',
    fontWeight: 'bold',
  },
  '& .field.empty': {
    backgroundColor: 'yellow',
  },
  '& .ql-editor': {
    ...sharedStyles,
  },
} as const;
